<template>
  <div>
    <b-field class="mgb-0">
      <router-link-blank
        v-if="afficherLienDetail"
        :to="{ name: 'c.bodac.clients/contacts-client', params: { id: intervenant.tiersId }}"
        :message="intervenant.nomCommercial"
        classMessage="has-text-weight-bold lien mgr-5px"/>
      <span v-else>{{ intervenant.nomCommercial }}</span>
      <p v-if="!titre">{{ `(${intervenant.repartition + typeRepartition})` }}</p>
      <b-tooltip
        v-if="intervenant.annonceur && func.getExonerationTva(intervenant)"
        :label="$t('ajoutDevis.clients.clientExonerationTva')"
        type="is-warning"
        position="is-right">
        <b-icon
          icon="earth-arrow-right"
          class="mgt-5px"
          size="is-small"
          type="is-warning">
        </b-icon>
      </b-tooltip>
      <span v-if="intervenant.payeur && intervenant.tiers.prospect">
        &nbsp;
      </span>
      <b-tooltip
        v-if="intervenant.payeur && intervenant.tiers.prospect"
        :label="$t('ajoutDevis.clients.prospect')"
        type="is-warning"
        position="is-right">
        <b-icon
          icon="account-search"
          class="mgt-5px"
          size="is-small"
          type="is-warning">
        </b-icon>
      </b-tooltip>
      <niveau-blocage-icone
          class="ml-2"
          v-if="intervenant.tiers && intervenant.tiers.blocageLevel"
          :niveau="intervenant.tiers.blocageLevel"
          :description="intervenant.tiers.descriptionBlocage"
          size="is-small"/>
    </b-field>
    <p v-if="titre">{{ titre }}</p>
    <multi-contact-intervenant :intervenant="intervenant"/>
    <div v-if="addressString || addressCpVille">
      <span> {{ $t('detail.client.address') }} <br> </span>
      <p v-if="addressString"> {{ addressString }} </p>
      <p v-if="addressCpVille"> {{ addressCpVille }} </p>
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';
import getExonerationTva from '@/services/tiers/getExonerationTva';
import niveauBlocageIcone from '@/components/general/NiveauBlocageIcone';
import { POURCENTAGE } from '@/configuration/devisConf';

export default {
  props: {
    intervenant: {
      type: Object,
      required: true,
    },
    afficherLienDetail: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    index: 0,
    func: { getExonerationTva },
  }),
  components: {
    routerLinkBlank,
    multiContactIntervenant,
    niveauBlocageIcone,
  },
  computed: {
    addressString() {
      const payeurAddress = this.intervenant.adressePostale;
      return payeurAddress.adresse1 || payeurAddress.adresse2;
    },
    addressCpVille() {
      const { codePostal, ville } = this.intervenant.adressePostale;
      return [codePostal, ville].filter(Boolean).join(' - ');
    },
    titre() {
      const { titre, repartition, payeur } = this.intervenant;
      if (!titre) return '';
      return [titre, payeur ? `(${repartition + this.typeRepartition})` : ''].filter(Boolean).join(' ');
    },
    typeRepartition() {
      return this.intervenant.typeRepartition === POURCENTAGE ? '%' : '€';
    },
  },
};
</script>
